<template>
  <div>
    <ConfigListItem
      :label="configDef.label"
      :value="strValue"
      :date="row && row.updatedAt"
      :login="row && row.updatedBy"
      @click="openEditDialog"
    />

    <ODialog ref="dialog">
      <v-card>
        <ODialogBar :title="configDef.label" @close="dismiss" />
        <v-card-text class="pa-6">
          <p v-if="configDef.description != null">
            {{ configDef.description }}
          </p>

          <OTextField
            v-if="configDef.type == 'number'"
            :label="configDef.label"
            v-model.number="clonedValue"
          />

          <v-list class="py-0" v-else-if="configDef.type == 'select'">
            <v-list-item
              class="px-6 rounded-lg"
              v-for="opt in configDef.opts"
              :class="{ 'oderon lighten-1': opt.value == clonedValue }"
              :key="opt.value"
              @click="clonedValue = opt.value"
            >
              <v-list-item-title class="d-flex align-center">
                <OCheckIcon
                  class="mr-4"
                  radio
                  :value="opt.value == clonedValue"
                />
                {{ opt.label }}
              </v-list-item-title>
            </v-list-item>
          </v-list>

          <span v-else>Unknown type: {{ configDef.type }}</span>
        </v-card-text>
        <ODialogButtons
          class="pa-6"
          txtApply="Salvar"
          @cancel="dismiss"
          @apply="save"
        />
      </v-card>
    </ODialog>
  </div>
</template>

<script>
import { formatValue } from '../configs/utils.js'
import ConfigListItem from './ConfigListItem.vue'
import { getCfg } from './config-utils.js'

// usado aqui e na tela de cópia de configs
export function displayValue(allConfigs, configDef) {
  let value = getCfg(allConfigs, configDef.code)
  return formatValue(value, configDef)
}

export function copyValue(allConfigs, configDef) {
  let value = getCfg(allConfigs, configDef.code)
  let result = { [configDef.code]: value }
  return result
}

export default {
  components: { ConfigListItem },
  props: {
    configDef: { required: true },
    allConfigs: { required: true }
  },
  data() {
    return {
      clonedValue: null
    }
  },
  computed: {
    row() {
      return this.allConfigs.find((x) => x.key == this.configDef.code)
    },
    strValue() {
      return formatValue(this.row && this.row.value, this.configDef)
    }
  },
  methods: {
    dismiss() {
      this.$refs.dialog.$dismiss()
    },
    openEditDialog() {
      this.clonedValue = this.row && this.row.value
      return this.$refs.dialog.$open()
    },
    async save() {
      const payload = { [this.configDef.code]: this.clonedValue }
      this.$emit('save', payload)
      this.dismiss()
    }
  }
}
</script>

<style lang="sass">
.selected-option
  background-color: #f7931e
</style>
